export default "__VITE_ASSET__BwXwEO7C__"